import './Modal.css';
export var BaseModalCSS = '_fpufjj0-2-0-1';
export var BaseModelSizesCSS = {small:'_fpufjj1-2-0-1',medium:'_fpufjj2-2-0-1',large:'_fpufjj3-2-0-1'};
export var ModalBackdropCSS = '_fpufjj4-2-0-1';
export var ModalHeaderCSS = '_fpufjj5-2-0-1';